import { useState, useEffect } from 'react';
import { RedButton } from '../components/common';
import { edit } from "@genfun/core/api/API";
import './EditPopup.css';

// Edit options - clothes and styles
const clothesOptions = [
    { icon: "💦", text: "Nude", data: { prompt: { action: "nude" } } },
    { icon: "🧦", text: "Stockings", data: { prompt: { action: "stockings" } } }
];

const stylesOptions = [
    { icon: "🎨", text: "Anime", data: { prompt: { action: "anime" } } },
    { icon: "🎮", text: "Pixel-art", data: { prompt: { action: "pixel" } } }
];

function CloseIcon() {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M1 1L11 11M1 11L11 1" stroke="#FFB2C6" strokeWidth="2" strokeLinecap="round"/>
        </svg>
    );
}

function OptionButton({ option, selected, onClick }) {
    return (
        <button
            className={`editOption ${selected ? 'editOptionSelected' : ''}`}
            onClick={onClick}
        >
            <span className="editOptionIcon">{option.icon}</span>
            <span className="editOptionText">{option.text}</span>
        </button>
    );
}

function OptionRow({ header, options, selectedPrompt, onSelect }) {
    return (
        <div className="editOptionRow">
            <h3 className="editOptionRowHeader">{header}</h3>
            <div className="editOptionRowButtons">
                {options.map((option) => (
                    <OptionButton
                        key={option.data.prompt.action}
                        option={option}
                        selected={selectedPrompt?.action === option.data.prompt.action}
                        onClick={() => onSelect(option.data.prompt)}
                    />
                ))}
            </div>
        </div>
    );
}

export function EditPopup({
    isOpen,
    setIsOpen,
    token,
    taskId,
    batchIdx,
    onEditStart,
    onEditComplete,
    onEditError,
    onPaymentRequired
}) {
    const [selectedPrompt, setSelectedPrompt] = useState(null);

    // Reset selection when popup opens
    useEffect(() => {
        if (isOpen) setSelectedPrompt(null);
    }, [isOpen]);

    const handleEdit = async () => {
        if (!selectedPrompt || !token) return;

        onEditStart?.();
        setIsOpen(false);

        try {
            const [response, status] = await edit(token, taskId, selectedPrompt, batchIdx, null);
            if (status === 402) {
                onPaymentRequired?.();
                return;
            }
            if (status !== 200) {
                onEditError?.("Edit failed. Please try again.");
                return;
            }
            onEditComplete?.(response.task_id);
        } catch (err) {
            onEditError?.("Failed to start edit");
        }
    };

    if (!isOpen) return null;

    return (
        <div className="editPopupOverlay" onClick={() => setIsOpen(false)}>
            <div className="editPopupPanel" onClick={e => e.stopPropagation()}>
                <button className="editPopupCloseBtn" onClick={() => setIsOpen(false)}>
                    <CloseIcon />
                </button>

                <h2 className="editPopupTitle">Choose edit</h2>

                <OptionRow
                    header="Clothes"
                    options={clothesOptions}
                    selectedPrompt={selectedPrompt}
                    onSelect={setSelectedPrompt}
                />

                <OptionRow
                    header="Styles"
                    options={stylesOptions}
                    selectedPrompt={selectedPrompt}
                    onSelect={setSelectedPrompt}
                />

                {selectedPrompt && (
                    <div className="editPopupButtonWrapper">
                        <RedButton onClick={handleEdit}>
                            Edit
                        </RedButton>
                    </div>
                )}
            </div>
        </div>
    );
}

export default EditPopup;
